import * as React from 'react';

/**
 * @typedef {Object} ImageState
 * @property {boolean} isOpen
 */

/**
 * @typedef {{[key:number]: Set<string>}} Images
 */

/**
 * @typedef {Object} AnchorState
 * @property {Images} images
 * @property {(step: number) => void} close
 * @property {(step: number, id: string) => void} open
 * @property {string} currentImage
 * @property {React.Dispatch<string>} setCurrentImage
 * @property {boolean} enableStepAnchor
 */

/**
 * @type {Images}
 */
import { jsx as _jsx } from "react/jsx-runtime";
let _images = {};

/**
 * @param {number} step
 * @param {string[]} images
 */
export function registerImages(step, images) {
  if (_images[step]) {
    images.forEach(image => {
      _images[step].add(image);
    });
  } else {
    _images[step] = new Set(images);
  }
}

/**
 * @param {number} step
 * @param {string} image
 */
export function registerImage(step, image) {
  if (!_images[step]) {
    _images[step] = new Set();
  }
  _images[step].add(image);
}

/**
 * @type {null | React.Context<AnchorState>}
 */
export const AnchorStateContext = /*#__PURE__*/React.createContext(null);
export function AnchorStateProvider(_ref) {
  let {
    children,
    stepAnchor,
    enableStepAnchor = false
  } = _ref;
  const images = React.useRef(_images);
  const [currentImage, setCurrentImage] = React.useState(null);
  const close = step => window.location.hash = stepAnchor + step;
  const open = (step, id) => window.location.hash = "" + stepAnchor + step + "_" + id;
  return /*#__PURE__*/_jsx(AnchorStateContext.Provider, {
    value: {
      images: images.current,
      close,
      open,
      currentImage,
      setCurrentImage,
      enableStepAnchor
    },
    children: children
  });
}